function normalizedEmails(value) {
  const values = Array.isArray(value) ? value : String(value || "").split(/[,;\s]+/);
  return values.map((item) => String(item || "").trim()).filter(Boolean);
}

export function inquiryEmailIdentity(inquiry = {}) {
  const senderEmail = String(inquiry.sender_email || "").trim();
  const customerEmail = String(inquiry.recipient_email || "").trim()
    || normalizedEmails(inquiry.recipient_emails)[0]
    || senderEmail;
  const relayEmail = senderEmail
    && customerEmail
    && senderEmail.toLocaleLowerCase() !== customerEmail.toLocaleLowerCase()
    ? senderEmail
    : "";

  return { customerEmail, relayEmail };
}
